/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Link_PickInputs */

const vi_shop_home_link_pick = /** @type {(inputs: Shop_Home_Link_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn…`)
};

/**

* @param {Shop_Home_Link_PickInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_link_pick = /** @type {((inputs?: Shop_Home_Link_PickInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Link_PickInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_link_pick(inputs)
});